import React from 'react';

const ThisVendorTable = (props) => {
    return (
        <tr key={props.index} className="image" onClick={() => props.editData(props.item)}>
            <td>
                {props.item.name}
            </td>
            <td>
                {props.item.code}
            </td>
            <td>
                {props.item.phone}
            </td>
        </tr>
    );
};

export default ThisVendorTable;